<template>
	<div>

		<EarningQuestBanner />

		<div class="mt-4"></div>

		<NetworkList />

		<div class="mt-8"></div>

		<InHouseTasks />

		<div class="mt-8"></div>

		<DeviceFilterComponent></DeviceFilterComponent>

		<v-divider class="my-4"></v-divider>

		<DailyQuests />

		<DailyPicks class="mt-8" />

		<DailyOffers class="mb-8" />


	</div>
</template>



<script setup>

import { onMounted } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import NetworkList from '@/components/Earn/Offerwall/Network-List.vue';
import DailyPicks from '@/components/Earn/DailyEarnings/Daily-Picks.vue';
import DailyOffers from '@/components/Earn/DailyEarnings/Daily-Offers.vue';
import DailyQuests from '@/components/Earn/DailyEarnings/Daily-Quests.vue';
import InHouseTasks from '@/components/Earn/InHouseTasks/InHouse-Tasks.vue';
import EarningQuestBanner from '@/components/Earn/Earning-Quest-Banner.vue';
import DeviceFilterComponent from '@/components/Common/Device-Filter-Component.vue';


const route = useRoute();
const router = useRouter();



onMounted(() => {
	const queryOfferId = route.query.offerId;
	if (queryOfferId && typeof queryOfferId === 'string') {
		// Redirect to the offers page with the offer ID as a route parameter
		router.push({
			name: 'OfferDetails',
			params: { offerId: queryOfferId.toString() }
		});
		return;
	}
});

</script>
